// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as XCloseDefault } from '../../../assets/icons/default/general/x-close.svg?react';
import { ReactComponent as XCloseSolid } from '../../../assets/icons/solid/general/X-CLOSE.svg?react';
import { createIcons } from '../../Icon';
const XCloseIcon = /* @__PURE__ */ createIcons('XClose', {
    default: XCloseDefault,
    solid: XCloseSolid
});
XCloseIcon.supportedTypes = ['default', 'solid'];
XCloseIcon.category = 'general';
export default XCloseIcon;
